/**
 * File track-double-cta.js.
 * Handles firing Segment events when double CTAs (Sign Up and Log In) are clicked.
 */

// Select both CTAs within the .double-cta-links container
const ctaLinks = document.querySelectorAll('.double-cta-links .cta-link');

const handleCtaClick = (cta) => {
  const ctaText = cta.textContent;
  const ctaHref = cta.getAttribute('href');
  const ctaType = ctaText.trim().toLowerCase() === 'sign up' ? 'Sign Up' : 'Log In';

  let properties = {
    interaction_type: "INTERACTION_TYPE_MODULE_ELEMENT_TAPPED",
    interaction_details: {
      action_detail: ctaText,
      additional_data: [
        {
          key: "cta_href",
          value: ctaHref
        },
        {
          key: "cta_type",
          value: ctaType
        },
      ],
    },
  };

  if (typeof segmentGenericEvent === 'function') {
    segmentGenericEvent('track', properties);
  }
}

ctaLinks.forEach(cta => {
  cta.addEventListener('click', (e) => handleCtaClick(e.target));
});